import React from 'react'
import { Alert } from "reactstrap";

export const ErrorMessage = ({ text, condition }) => {
  if (condition)
    return (
      <Alert
        color="danger"
        className="alert"
        fade={true}
        style={{ textAlign: "center" }}
      >
        <p>{text}</p>
      </Alert>
    )
}
